import { YomiriLoading } from '../components/YomiriLoading.tsx';
import { lazy, Suspense, useEffect, useState } from 'react';
import { YomiriDiscoverView } from './YomiriDiscoverView.tsx';
const SourceView = lazy(() => import('./YomiriAnimeView.tsx').then(module => ({ default: module.YomiriAnimeView })));

export function YomiriAnimeEntry() {
  const [route, setRoute] = useState(location.search);
  useEffect(() => { const changed = () => setRoute(location.search); window.addEventListener('popstate', changed); return () => window.removeEventListener('popstate', changed); }, []);
  const params = new URLSearchParams(route);
  const hasDirectAnime = !!(params.get('anime') || params.get('episode'));

  if (!hasDirectAnime) {
    return <YomiriDiscoverView type="ANIME" />;
  }

  return <Suspense fallback={<YomiriLoading label="Abriendo anime" />}><SourceView key={params.get('episode') || params.get('anime') || 'catalog'} /></Suspense>;
}
